module.exports = __webpack_public_path__ + "static/1-layer3-1f4c7e3cc9ec763ab7628ef1c5aa3ebe.svg";